import { render, staticRenderFns } from "./animateplane.vue?vue&type=template&id=361179ae&scoped=true"
import script from "./animateplane.vue?vue&type=script&lang=js"
export * from "./animateplane.vue?vue&type=script&lang=js"
import style0 from "./animateplane.vue?vue&type=style&index=0&id=361179ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361179ae",
  null
  
)

export default component.exports